export default __webpack_public_path__ + "static/media/groups.a908935c.svg";